import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NotificationComponent } from '@pkg-components/notification/notification/notification.component';
import { ModalContainerComponent } from '@app/components/modal/modal-container.component';
import { DeleteConfirmPopInHostComponent } from '@pkg-components/confirm/delete-confirm-pop-in-host/delete-confirm-pop-in-host.component';
import { ApiCallService } from '@pkg-services/callApi/api-call.service';
import { AdminActionCenterService } from '@pkg-services/admin/admin-action-center.service';
import { AdminService } from '@pkg-services/admin/admin.service';
import type { Admin } from '@pkg-framework/models/admin';
import { RouteAdminMe, RouteAdminRightsDefinition } from '@pkg-framework/models/admin';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,
    HeaderComponent,
    SidebarComponent,
    NotificationComponent,
    ModalContainerComponent,
    DeleteConfirmPopInHostComponent,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  sidebarOpen = true;
  isMobileMenuOpen = false;

  constructor(
    private api: ApiCallService,
    private adminService: AdminService,
    private actionCenter: AdminActionCenterService
  ) {}

  ngOnInit(): void {
    if (!this.adminService.getCurrentAdmin()) {
      this.api.get(RouteAdminMe).subscribe({
        next: (res: { data: { admin: Admin } }) => {
          this.adminService.setCurrentAdmin(res.data.admin);
        }
      });
    }
    if (!this.adminService.getRightsDefinition()) {
      this.api.get(RouteAdminRightsDefinition).subscribe({
        next: (res: { data: Record<string, { label: string; description: string }> }) => {
          this.adminService.setRightsDefinition(res.data);
        }
      });
    }
    this.actionCenter.refresh().subscribe({ error: () => {} });
    this.actionCenter.startCountsPolling();
  }

  ngOnDestroy(): void {
    this.actionCenter.stopCountsPolling();
  }

  get isMobile(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  toggleSidebar(): void {
    if (this.isMobile) {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    } else {
      this.sidebarOpen = !this.sidebarOpen;
    }
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }
}
